import React from 'react';
import '../../../sass/agentSignatures/notice.scss';

const Notice = ({ children }) => <div className="notice">{children}</div>;

export default Notice;
